import { createFormAction } from 'redux-form-saga'
export const FORM_KEY = 'GUIDE_FORM'
export const GuideFormAction = createFormAction(FORM_KEY)